export interface IEmail
{
    id:number,
    emailAddress:string,
    emailType:number
}


export class Email implements IEmail
{
    constructor
    (
        public id: number,
        public emailAddress:string,
        public emailType:number
    )
    {}
}

export class EmailInsert
{
    constructor
    (
        email: IEmail
    )
    {
        this.emailAddress = email.emailAddress;
        this.emailType = email.emailType;
    }

    emailAddress:string;
    emailType:number;
}

export class EmailUpdate
{
    constructor
    (
        public id: number,
        public emailAddress?:string,
        public emailType?:number
    )
    {}
    
}